export default "__VITE_ASSET__BuyWmKKV__"